/**
 * core/gallery/frontend.js
 * 
 * @author jjarolim
 */

import $ from 'jquery'
import Swiper from 'swiper'
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'
import 'photoswipe/style.css';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

/**
 * Helper functions
 */

const initializeSwiper = () => {

    const params = {

        modules: [ Navigation ],

        // Defaults

        autoWidth: true,
        grabCursor: true,
        initialSlide: 1,
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 30,
        speed: 1000,
        loop: true,

        // Navigation

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    }

    /* Initialize Cover-Slider Swiper && Magnificent Popup */
    console.log(document.querySelectorAll( '.wp-block-gallery__swiperjs' ));
    for ( const element of document.querySelectorAll( '.wp-block-gallery__swiperjs' ) ) {
        const swiperSelected = element.querySelector( '.swiper' );
        const swiper = new Swiper( swiperSelected, params ); 
        initializePhotoswipe(swiper);
    }

}

const initializePhotoswipe = (swiper) => { 
    const photoswipe = new PhotoSwipeLightbox({
        gallerySelector: '.swiper-wrapper',
        childSelector: '.swiper-slide > a',
        pswpModule: PhotoSwipe
    })
    photoswipe.init();

    photoswipe.on('change', function(e) {
        console.log(e);
        const pswp = photoswipe.pswp.currIndex;
        swiper.slideTo(pswp);
        console.log(pswp);
    });
}

initializeSwiper();